import {forwardRef, type Ref} from 'react'
import {CopyToClipboardButton} from '@github-ui/copy-to-clipboard/Button'
import {FormControl, TextInput} from '@primer/react'

import styles from './NewBranchName.module.css'
import {clsx} from 'clsx'

export const NewBranchName = forwardRef(function NewBranchName(
  {
    newBranchName,
    setNewBranchName,
  }: {
    newBranchName: string
    setNewBranchName: (newName: string) => void
  },
  ref?: Ref<HTMLInputElement>,
) {
  return (
    <FormControl>
      <FormControl.Label>New branch name</FormControl.Label>
      <div className={styles.NewBranchNameInputGroup}>
        <TextInput
          block
          className={clsx('color-bg-subtle', styles.TextInput)}
          value={newBranchName}
          onChange={e => setNewBranchName(e.target.value)}
          ref={ref}
        />
        <div className={clsx('color-bg-subtle', styles.copyButtonContainer)}>
          <CopyToClipboardButton
            tooltipProps={{direction: 'nw'}}
            textToCopy={newBranchName}
            ariaLabel="Copy to clipboard"
            className={clsx(styles.CopyToClipboardButton)}
          />
        </div>
      </div>
    </FormControl>
  )
})

try{ NewBranchName.displayName ||= 'NewBranchName' } catch {}